export enum Positions {
  B = 'bottom',
  BL = 'bottom-left',
  BR = 'bottom-right',
  L = 'left',
  LT = 'left-top',
  LB = 'left-bottom',
  R = 'right',
  RT = 'right-top',
  RB = 'right-bottom',
  T = 'top',
  TL = 'top-left',
  TR = 'top-right',
  C = 'center',
}

export function invertPosition(position: Positions) {
  if (position === Positions.T) return Positions.B
  if (position === Positions.B) return Positions.T

  if (position === Positions.L) return Positions.R
  if (position === Positions.R) return Positions.L
}
